<template>
  <el-form :model="vendorInfo"
           :disabled="formStatus === 'detail'"
           ref="ruleForm"
           :rules="formStatus === 'detail' ? {} : rules"
           label-position='top'>
    <layout-card-wrap hasHeaderSlot
                      v-loading="loading">
      <template slot="title">基本信息</template>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="企业名称:"
                        prop="vendorName">
            <el-input v-model="vendorInfo.vendorName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人:"
                        prop="vendorPerson">
            <el-input v-model="vendorInfo.vendorPerson"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人手机号:"
                        prop="vendorPhone">
            <el-input v-model="vendorInfo.vendorPhone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="统一社会信用代码:"
                        prop="unifiedCreditCode">
            <el-input v-model="vendorInfo.unifiedCreditCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电子邮箱:"
                        prop="vendorEmail">
            <el-input v-model="vendorInfo.vendorEmail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="贸易类型:"
                        prop="tradeTypes">
            <el-checkbox-group v-model="vendorInfo.tradeTypes">
              <el-checkbox label="1">进出口</el-checkbox>
              <el-checkbox label="3">内销</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="企业地址:"
                        prop="vendorAddress">
            <el-input v-model="vendorInfo.vendorAddress"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="企业账号:"
                        prop="adminAccount">
            <el-input v-model="vendorInfo.adminAccount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属机构:"
                        prop="regulators">
            <supervision-select :isEdit="formStatus === 'edit'"
                                v-model="vendorInfo.regulators" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="行业配置:"
                        prop="categorys">
            <industry-select :isEdit="formStatus === 'edit'"
                             v-model="vendorInfo.categorys" />
          </el-form-item>
        </el-col>
        <el-col :span="8"
                v-if="!userPermission.SUPERVISE">
          <el-form-item label="标签类型:"
                        prop="tagTypes">
            <el-select v-model="vendorInfo.tagTypes"
                       style="width: 100%"
                       multiple
                       placeholder="请选择">
              <el-option v-for="item in tags"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否套码:"
                        prop="tagModels">
            <el-checkbox-group v-model="vendorInfo.tagModels">
              <el-checkbox label="1">产品码</el-checkbox>
              <el-checkbox label="2">套码</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="赋码方式:"
                        prop="codingTypes">
            <el-checkbox-group v-model="vendorInfo.codingTypes">
              <el-checkbox label="1">建批赋码</el-checkbox>
              <el-checkbox label="2">出库赋码</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出库对接:"
                        prop="outstockApi">
            <el-switch v-model="vendorInfo.outstockApi"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="1"
                       :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="关闭标签统计总量:"
                        prop="notshowTagTotalUsedCount">
            <el-switch v-model="vendorInfo.notshowTagTotalUsedCount"
                       active-color="#13ce66"
                       inactive-color="#ff4949"
                       :active-value="1"
                       :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="进出口H5模板:"
                        prop="h5Template">
            <wap-template-select v-model="vendorInfo.h5Template" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="国内H5模板:"
                        prop="h5TemplateInland">
            <wap-template-select :tradeType="3"
                                 v-model="vendorInfo.h5TemplateInland" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="营业执照:"
                        prop="businessLicenceFile">
            <upload-image :status="formStatus"
                          v-model="vendorInfo.businessLicenceFile"
                          :limit="1" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="注册域名:">
            <template v-if="vendorInfo.registrationUrl">
              <span> {{vendorInfo.registrationSystemName || '-'}} </span>
              <span>（{{ vendorInfo.registrationUrl }}）</span>
            </template>
            <template v-else>
              <span> - </span>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邀请人员:"> {{vendorInfo.inviteStaffName || '-'}} </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="推荐机构:"> {{vendorInfo.regulatorName || vendorInfo.inviteRegulatorName || '-'}} </el-form-item>
        </el-col>
      </el-row>
    </layout-card-wrap>
    <layout-card-wrap v-if="userPermission.OPERATE"
                      style="margin-top:10px;"
                      hasHeaderSlot
                      v-loading="loading">
      <template slot="title">功能权限</template>
      <el-form-item prop="functions">
        <checkbox-tree :treeData="vendorInfo.menuNodes"
                       nodeKey="funcId"
                       :defaultProps="defaultProps"
                       v-model="vendorInfo.functions" />
      </el-form-item>
    </layout-card-wrap>
  </el-form>
</template>

<script>
import BaseData from '@/utils/baseData'
import SupervisionSelect from './supervision-select.vue'
import IndustrySelect from './industry-select.vue'
import CheckboxTree from '@/components/public/checkbox-tree.vue'
import UploadImage from '@/components/public/upload-image-new.vue'
import { mapState } from 'vuex'
import WapTemplateSelect from '../../../components/wap-template-select.vue'
export default {
  name: 'vendor-form',
  components: { SupervisionSelect, IndustrySelect, CheckboxTree, UploadImage, WapTemplateSelect },
  props: {
    loading: [Boolean],
    formStatus: {
      type: String,
      default: 'edit'
    },
    value: {
      type: Object
    }
  },
  data () {
    return {
      tags: BaseData.tags,
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      // vendorInfo: {
      //   menuNodes: []
      // },
      rules: {
        vendorName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 30, message: '长度最大 30 个字符', trigger: 'blur' }
        ],
        vendorPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        vendorPhone: [
          { pattern: /^1[0-9][0-9]\d{8}$/, required: true, message: '请输入正确的联系人手机号', trigger: 'blur' }
        ],
        unifiedCreditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        vendorEmail: [
          { type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        tradeTypes: [
          { type: 'array', required: true, message: '请至少选择一个贸易类型', trigger: 'blur' }
        ],
        vendorAddress: [
          { required: false, message: '请输入企业地址', trigger: 'blur' }
        ],
        adminAccount: [
          { required: true, message: '请输入企业账号', trigger: 'blur' }
        ],
        regulators: [
          { type: 'array', required: true, message: '请至少选择一个所属机构', trigger: 'blur' }
        ],
        categorys: [
          { type: 'array', required: true, message: '请至少选择一个行业', trigger: 'blur' }
        ],
        tagTypes: [
          { type: 'array', required: true, message: '请至少选择一个标签类型', trigger: 'blur' }
        ],
        tagModels: [
          { type: 'array', required: true, message: '请至少选择一个套码类型', trigger: 'blur' }
        ],
        codingTypes: [
          { type: 'array', required: true, message: '请至少选择一个赋码方式', trigger: 'blur' }
        ],
        businessLicenceFile: [
          { required: true, message: '请上传营业执照', trigger: 'blur' }
        ],
        functions: [
          { type: 'array', required: true, message: '请至少选择一个功能权限', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    }),
    vendorInfo: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  // watch: {
  //   info: {
  //     handler (val) {
  //       this.vendorInfo = {
  //         ...this.vendorInfo,
  //         ...val
  //       }
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    validate (status, cb) {
      if (status === 2) {
        cb && cb(this.vendorInfo)
      } else {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            cb && cb(this.vendorInfo)
          }
        })
      }
    }
  },
  created () { },
  mounted () { }
}
</script>
